import { required } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
import "vue-toastification/dist/index.css"
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "El campo {_field_} no puede estar vacio"
})


const auth = {
    components: { ValidationProvider, ValidationObserver },
    data: () => ({
        loading: false,
        invalided: false,
        step: 1,
        imageUrl: '/imgs/Business-Background-PNG.png',
        rememberMe: false,
        user: {
            user: null
        }
    }),
    methods: {
        async sendEmail() {
            this.loading = true;
            if (this.user.user == null) {
                this.loading = false;
                return false;
            }

            const userExist = await this.$axios.post('/forget/password', { usuario: this.user.user })

            if (userExist.data.status) {
                this.invalided = true;
                this.$toast.success(userExist.data.msg, {
                    timeout: 3436,
                });

                // await setTimeout(() => 
                //     this.$router.push("/reset/count")
                //     , 4000);

            } else {
                this.$toast.error(userExist.data.msg, {
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
            }
            this.loading = false;

        }
    }
}



export default auth